import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

interface CommercialRouteProps {
  children: ReactNode;
}

const CommercialRoute = ({ children }: CommercialRouteProps) => {
  const { auth } = useAuth();
  const location = useLocation();
  
  if (auth.isLoading || !auth.initialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }
  
  if (!auth.isAuthenticated) {
    return <Navigate to={`/login?redirect=${location.pathname}`} state={{ from: location }} replace />;
  }
  
  if (
    auth.user?.role !== 'commercial' &&
    auth.user?.role !== 'distributor' &&
    auth.user?.role !== 'admin' &&
    auth.user?.role !== 'beeadmin'
  ) {
    return <Navigate to="/account" replace />;
  }
  
  return <>{children}</>;
};

export default CommercialRoute;








